import script from "./index2.vue?vue&type=script&setup=true&lang=js"
export * from "./index2.vue?vue&type=script&setup=true&lang=js"

import "./index2.vue?vue&type=style&index=0&id=5ab95023&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.27_vue@3.4.27_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ab95023"]])

export default __exports__